import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Nav from "../../Components/Nav/Nav.jsx";
import Header from "./Header.jsx";


import './DoctorProfile.css';
import pic1 from './patient.jpg';



export const DoctorProfile = (props) => {


  return (
    <div>
            <Nav title="HEALTHसखा" />
            <Header/>

                
            </div>
  )
}

